import { BaseButton } from '@/components/Buttons/Core/BaseButton';
import { withStyles } from '@/components/Buttons/Core/withStyles';

export const DangerButton = withStyles(BaseButton, {
    light: 'red.500',
    dark: 'red.700',
    textStyle: {
        color: 'white',
        light: 'white',
        dark: 'white',
    }
});